'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Immutable = require('Immutable');

exports.default = (0, _Immutable.Record)({
  timeUnit: null,
  numberOfTimeUnits: null
}, 'Reminder');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsBase/target/src/MeetingsBase/static-1.2449/js/models/Reminder.js
// module id = 329
// module chunks = 0